// extracted by mini-css-extract-plugin
export default {"segmented":"segmentedComTryon_segmented__RGe6U","SegmentedContent":"segmentedComTryon_SegmentedContent__8QJ-Z","Placeholder":"segmentedComTryon_Placeholder__h5kfC"};